package com.zaurh.mapquizwebsite.domain.model.request

import kotlinx.serialization.Serializable

@Serializable
data class SignInRequest(
    val username: String
)
